import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import useStyles from './useStyles';
import { FileUploadIcon } from './assets';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { CapaConnectFileUpload } from '@api/rest';
import { CircularProgress } from '@material-ui/core';

interface Props {
  onRefetchMyDrive: () => void;
}

const ConnectDriveDropzone = ({ onRefetchMyDrive }: Props) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length === 0) return;

      setLoading(true);

      return Promise.all(
        acceptedFiles.map(async (file) => {
          const formData = new FormData();

          formData.append('files', file);
          formData.append('pathId', '');

          await CapaConnectFileUpload('/connect', formData);

          await onRefetchMyDrive();
        })
      ).finally(() => setLoading(false));
    },
    [onRefetchMyDrive]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    noClick: true
  });

  const onOpen = () => {
    const inputRef = document.getElementById('connect-upload-input');

    if (inputRef) {
      inputRef.click();
    }
  };

  return (
    <div
      {...getRootProps({ className: classes['Connect-Drive-Dropzone-root'] })}
    >
      <input {...getInputProps({ id: 'connect-upload-input' })} />

      <div className="inner_box">
        {loading ? (
          <CircularProgress color="primary" />
        ) : (
          <>
            <img className="file_upload_icon" src={FileUploadIcon} alt="" />

            {isDragActive ? null : (
              <>
                <CustomizedTypography
                  variant="body1"
                  color="textPrimary"
                  fontWeight="bold"
                  gutterBottoms={4}
                >
                  파일 업로드
                </CustomizedTypography>

                <CustomizedTypography
                  variant="body2"
                  color="textSecondary"
                  align="center"
                  gutterBottoms={20}
                >
                  파일을 드라이브로 바로 드래그하여
                  <br />
                  업로드할 수 있습니다
                </CustomizedTypography>

                <CustomizedButton
                  color="primary"
                  variant="text"
                  onClick={onOpen}
                >
                  내 PC에서 첨부
                </CustomizedButton>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ConnectDriveDropzone;
